import type { FaireProductEntity } from "../../entity_types/product";

export const p_a64es5nszb: FaireProductEntity = {
  token: "p_a64es5nszb",
  type: "product",
  name: "Coneflower Kitchen Towel",
  brandToken: "b_4knjkc8j",
  brandName: "Primitives by Kathy",
  imageUrl: "https://cdn.faire.com/fastly/4906d8da9bbc4acfb0d92991e77b26c4ffaabb015ee8af9bd4427abc7dd8d270.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b8ace47deb90faa2ff80bdcb3287a331baa0b853c3b04b624a559c6cbf5ea74d.jpeg",
    "https://cdn.faire.com/fastly/391509e6ca404d89fcf9f72ee2839d313b1a96d342baad0c857cc32dec4b5047.jpeg",
    "https://cdn.faire.com/fastly/605d7b2d0fb7c6126c06f7320342f447baa4dbb3d7249acea4c97177c07f6e69.jpeg",
    "https://cdn.faire.com/fastly/32e1f3b98d7d38a39e19245c25ca45d7d34628056a11c5ca1e48ff2d023a1e3d.jpeg",
    "https://cdn.faire.com/fastly/bd8281b1f23df5aa3819c5c3def690e0aa033050791debe068ee5ed5be681204.jpeg",
    "https://cdn.faire.com/fastly/bd810519ed922f6d1c4e7e97463e449ba8e87b9c85b726da00021bc9714be08c.jpeg"
  ],
  priceDollars: 8,
  description: "A microfiber kitchen towel from our Garden Collection featuring an all-over design displaying a calming scene of bees in a field of coneflowers. The coneflower design is replicated from original artwork painted onto burlap canvas, giving the art a unique depth and texture. Double-sided towel displays a coordinating stripe pattern on the back that offers multiple display options with a cotton tape hanger in the corner for hanging. Our Coneflower kitchen towel is conveniently machine washable for easy cleaning. Microfiber towel is packaged on a cardboard hanger with hole to easily display on store rack. A garden-themed kitchen accessory that easily adds personal style to any kitchen.",
  tags: [],
  msrpDollars: 15.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:04:24.271Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
